import { useCallback, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import * as CensusActions from "../redux/actions/CensusAction"
import { HideSpinner, ShowSpinner } from "../redux/actions/SpinnerAction";
import { ErrorToast } from "../redux/actions/ToasterAction";

import { useHierarchyService } from "./useHierarchyService";

import { FormattedDateString } from "../utilities/DateHelper";
import { ExpandAll } from "../utilities/TreeHelper";
import Services from "../service/ApiServices"
import _ from "lodash";


const useCensus = ({refreshTree = true})=>{  
    const {data:{selectedTreeNode}, actions:{GetMultipleLocationTreeWithFilter,  RefreshTree} }= useHierarchyService(); 
   
    const filter = useSelector((state)=>{
        return state.census.filter;
    })

    const isFilterApplied = useSelector((state)=>{
        return state.census.isFilterApplied;
    })

    const selectedLocations = useSelector((state)=>{
        return state.census.filter.selectedLocations
    })

    const defaultExpandedKeys = useSelector((state)=>{
        return state.census.defaultExpandedKeys;
    })

    const clientStatus = useSelector((state)=>{
        return state.census.clientStatus;
    })

    const dispatchCensus = useDispatch();

    const InitializeDefaults = useCallback((date, selectedLocations)=>{
        var action = CensusActions.InitialDefaults(date, selectedLocations)
        dispatchCensus(action) 
    }, [dispatchCensus])

    const SetSelectedLocations = useCallback((selectedLocations)=>{
        var action = CensusActions.SetSelectedLocations(selectedLocations)
        dispatchCensus(action)
    }, [dispatchCensus])

    const SetSelectedDate = useCallback((date)=>{
        var action =  CensusActions.SetSelectedDate(date);       
        dispatchCensus(action);   

    }, [dispatchCensus])

    const SetFilter = useCallback((data)=>{
        var action =  CensusActions.SetFilter(data);       
        dispatchCensus(action);   

    }, [dispatchCensus])

    const ResetFilter = useCallback((data)=>{
        var action =  CensusActions.ResetFilter(data);       
        dispatchCensus(action);   

    }, [dispatchCensus])

    const SetDefaultExpandedKeys = useCallback((expandedKeys)=>{
        var action = CensusActions.SetDefaultExpandedKeys(expandedKeys);
        dispatchCensus(action);
    }, [dispatchCensus])

    const SetClientStatus = useCallback((data)=>{
        var action = CensusActions.SetClientStatus(data);
        dispatchCensus(action);
    }, [dispatchCensus])

    const AssignOrReserveBed = useCallback(async(data)=>{
        try{
            dispatchCensus(ShowSpinner());     
            var action = await  CensusActions.AssignOrReserveBed(selectedTreeNode, data);
            dispatchCensus(HideSpinner());
            dispatchCensus(action); 
            await RefreshTree(filter)
        }  
        catch(err) {         
            dispatchCensus(HideSpinner());
            dispatchCensus(ErrorToast('Error', _.get(err, 'response.data.message') || err));
          }    

    }, [dispatchCensus, RefreshTree, filter, selectedTreeNode])

    const MoveClient = useCallback(async(data)=>{
        try {
            dispatchCensus(ShowSpinner());     
            var action = await  CensusActions.MoveClient(selectedTreeNode, data);
            dispatchCensus(HideSpinner());
            dispatchCensus(action);  
            await RefreshTree(filter)     
        }
        catch(err){
            dispatchCensus(HideSpinner());
            dispatchCensus(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }

    }, [dispatchCensus, RefreshTree, filter, selectedTreeNode])


    const RemoveAssignOrReserve = useCallback(async (data)=>{
        try{
                const canRemove = await Services.Census.canRemoveAssignment({bedId:data.bedId, clientId:data.client.id, date:data.date})
            if(canRemove.flag){
                    dispatchCensus(ShowSpinner);
                    var action = await  CensusActions.RemoveAssignOrReserve(selectedTreeNode, data);
                    dispatchCensus(HideSpinner());
                    dispatchCensus(action); 
                    await RefreshTree(filter) 
            }else{
                    dispatchCensus(ErrorToast('Error', `Unable to remove ${data.client.fullName} due to future recorded attendance`));
            } 
        }catch(err){
            dispatchCensus(HideSpinner());
            dispatchCensus(ErrorToast('Error', _.get(err, 'response.data.message') || err));
        }
    }, [dispatchCensus, RefreshTree, filter, selectedTreeNode])

   
   
    useEffect(()=>{       
        const GetTreeDataAsync = async ()=>{
            if(refreshTree && !_.isNull(filter.date) && !_.isNull(filter.selectedLocations)){         
                const treeData = await GetMultipleLocationTreeWithFilter({...filter, date:FormattedDateString(filter.date), locationIds:filter.selectedLocations.map((l)=>l.id)} ) 
                let expandedKeys = {};   
                isFilterApplied && _.forEach(treeData, (tree)=>{expandedKeys = {...expandedKeys, ...ExpandAll(tree, expandedKeys)}});
                SetDefaultExpandedKeys(expandedKeys)
            }
        }
        GetTreeDataAsync();
    }, [refreshTree, filter, isFilterApplied, GetMultipleLocationTreeWithFilter, SetDefaultExpandedKeys])

    return {data:{selectedLocations, filter, isFilterApplied, defaultExpandedKeys, clientStatus}, actions:{InitializeDefaults, SetSelectedLocations, SetSelectedDate, SetFilter, ResetFilter, AssignOrReserveBed, RemoveAssignOrReserve, MoveClient, SetClientStatus}}
}

export default useCensus